import { useBreakpoint } from 'src/hooks';
import styles from './ManageAccountContentPage.module.scss';
import { X } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import { SVG_SIZE_L } from 'src/constants';
import { AppRoutes } from 'src/types';
import cn from 'classnames';
import { MainNavToggleButton } from 'src/pages/ManageTasksChatPage/components/ConversationsHeader/components/MainNavToggleButton';
import { useFeatureFlagEnabled } from 'posthog-js/react';
import { GoBackButton } from 'src/components/GoBackButton';

interface ManageAccountContentPageProps {
  title: string;
  subtitle?: string;
  children: JSX.Element;
  className?: string;
  errorMessage?: string;
  isFullWidth?: boolean;
  isWithBackButton?: boolean;
}

export const ManageAccountContentPage = ({
  title,
  subtitle,
  children,
  className,
  errorMessage,
  isFullWidth,
  isWithBackButton,
}: ManageAccountContentPageProps) => {
  const { isDesktopAndUp, isMobileOrTablet } = useBreakpoint();
  const isWithHiddenLeftPanel = useFeatureFlagEnabled('hideLeftPanelInMN');

  return (
    <div className={cn(styles.root, className)}>
      <div className={cn(styles.header, { [styles.fullWidth]: isFullWidth })}>
        {isMobileOrTablet && !(isWithBackButton && isWithHiddenLeftPanel) && (
          <div className={styles.toggleButtonWrapper}>
            <MainNavToggleButton />
          </div>
        )}

        {isWithBackButton && isWithHiddenLeftPanel ? (
          <div className={styles.titleWrapper}>
            <GoBackButton />
            <span className={styles.title}>{title}</span>
          </div>
        ) : (
          <h3 className={styles.title}>{title}</h3>
        )}
        {subtitle && isDesktopAndUp && (
          <h5 className={styles.subtitle}>{subtitle}</h5>
        )}

        {errorMessage && (
          <h5 className={styles.errorMessage}>{errorMessage}</h5>
        )}

        {!(isWithBackButton && isWithHiddenLeftPanel) && (
          <Link to={AppRoutes.HOME} className={styles.back}>
            <X size={SVG_SIZE_L} />
          </Link>
        )}

        {isDesktopAndUp && <hr className="divider" />}
      </div>

      <div className={styles.containerWrapper}>
        <div
          className={cn(styles.container, { [styles.fullWidth]: isFullWidth })}
        >
          {children}
        </div>
      </div>
    </div>
  );
};
